angular.module('nv.singleStudent').component('studentFullTranscriptHistoryPanel', {
  // tslint:disable-next-line:max-line-length
  template: require('./student-full-transcript-history-panel.html'),
  bindings: {
    student: '=',
  },
  controller: 'StudentFullTranscriptHistoryPanelCtrl',
});
